import src from './http'
let images = {
  tab1def: '1_default.png',
  tab1act: '1_active.png',
  tab2def: '2_default.png',
  tab2act: '2_active.png',
  tab3def: '3_default.png',
  tab3act: '3_active.png',
  tab4def: '4_default.png',
  tab4act: '4_active.png',
  headRight: 'right.png',
  headSearch: 'search.png',
  headLogo: 'logo.png',
  randomCall: 'callphone.png',
  userGirl: 'girl.png',
  userBoy: 'boy.png',
  userAvatarDef: 'avatar-default.png',
  popupClose: 'close.png',
  homeFree: 'free.png'
}

for (let i in images) {
  if (i.indexOf('tab') > -1) {
    images[i] = src(`tabbar/${images[i]}`)
  }
  if (i.indexOf('head') > -1) {
    images[i] = src(`header/${images[i]}`)
  }
  if (i.indexOf('random') > -1) {
    images[i] = src(`random/${images[i]}`)
  }
  if (i.indexOf('user') > -1) {
    images[i] = src(`user/${images[i]}`)
  }
  if (i.indexOf('popup') > -1) {
    images[i] = src(`popup/${images[i]}`)
  }
  if (i.indexOf('home') > -1) {
    images[i] = src(`home/${images[i]}`)
  }
}

export default images



// WEBPACK FOOTER //
// ./src/config/images.config.js